import { render } from "./CenterSpotsPage.vue?vue&type=template&id=64e0b27e"
import script from "./CenterSpotsPage.vue?vue&type=script&lang=js"
export * from "./CenterSpotsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__